<template>
    <UiGeneralText id="UiGeneralText" :blok="blok" />
</template>

<script setup>
defineProps({ blok: Object });
</script>
<style lang="postcss" scoped>
:deep(#UiGeneralText) {
    .rich-text {
        a:hover {
            @apply brightness-[95%];
        }
    }
}
:deep(.text-primary) {
    @apply static text-[#666] not-italic leading-[inherit] text-center box-border text-[14px] font-normal;
}
</style>
